import palette from "../palette";

export default {
  root: {},
  colorPrimary: {
    color: palette.primary.main,
  },
};
